import { Loader2 } from "lucide-react";

const STATE = {
  ok: { icon: "✅", text: "Conectado" },
  error: { icon: "❌", text: "No conecta" },
  probando: { icon: "⏳", text: "Probando…" },
};

// «Qué está listo y qué falta»: una fila por servidor (conexión, análisis, base de datos) y las credenciales pendientes.
export function ReadinessList({ readiness }) {
  if (!readiness) {
    return (
      <div data-testid="readiness-loading" className="flex items-center gap-2 text-xs text-muted-foreground">
        <Loader2 className="h-3.5 w-3.5 animate-spin" /> Revisando el estado de los servidores…
      </div>
    );
  }
  const { servers = [], pending = [], analyzing, ready } = readiness;
  return (
    <div data-testid="readiness-list" className="space-y-2 text-sm">
      {servers.map((s) => {
        const st = STATE[s.state] || STATE.probando;
        return (
          <div key={s.id} data-testid={`readiness-server-${s.name}`} className="rounded-lg border border-border p-2.5 space-y-0.5">
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <span className="font-medium">
                {s.name} <span className="text-xs text-muted-foreground font-normal">{s.kind === "routeros" ? "MikroTik" : s.kind === "olt" ? "OLT" : "Linux"}{s.via ? ` · vía ${s.via}` : ""}</span>
              </span>
              <span className="text-xs">{st.icon} {st.text}</span>
            </div>
            {s.state === "error" && s.message && <p className="text-xs text-muted-foreground">{s.message}</p>}
            {s.kind === "linux" && s.state === "ok" && (
              <p className="text-xs text-muted-foreground">
                {s.analyzed ? "✅ Analizado" : "⏳ Analizando (≈1 minuto)…"}
                {s.analyzed && s.db ? ` · Base de datos: ${s.db}` : ""}
              </p>
            )}
          </div>
        );
      })}
      {pending.length > 0 && (
        <div data-testid="readiness-pending" className="rounded-lg border border-amber-500/40 p-2.5 space-y-1.5">
          <p className="text-xs font-medium text-amber-500">Faltan credenciales (pégalas con el candado 🔒 del chat):</p>
          {pending.map((p, i) => (
            <div key={`${p.name}-${i}`} data-testid={`readiness-pending-${i}`} className="text-xs space-y-0.5">
              <p>❌ <span className="font-medium">{p.name}</span> — falta {p.need || "usuario y contraseña"}</p>
              {p.example && <p className="font-mono text-muted-foreground break-all">{p.example}</p>}
            </div>
          ))}
        </div>
      )}
      {ready && (
        <p data-testid="readiness-ready" className="text-xs text-emerald-500">✅ Todo listo: el proyecto está funcional para trabajar.</p>
      )}
      {!ready && analyzing && pending.length === 0 && (
        <p className="text-xs text-muted-foreground">Ya puedes abrir el proyecto; el análisis termina solo en segundo plano.</p>
      )}
    </div>
  );
}
